import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FieldConfig } from '../field-interface';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MetalRatesService } from 'src/app/services/metal-rates.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;
  data: any;
  b2bPricingEnabled: boolean = false;
  textAccount: string;
  specialPriceChangeOnPriceDiscount: any = 0;

  constructor(
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private metalRatesService: MetalRatesService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit() {

    let data = JSON.parse(localStorage.getItem("value"));


    this.specialPriceChangeOnPriceDiscount = data['specialPriceChangeOnPriceDiscount'] == undefined ? 0 : data['specialPriceChangeOnPriceDiscount'];


    this.textAccount = 'OK';

    let value = JSON.parse(localStorage.getItem('value'))

    // console.log(value);

    if (value['b2bPricingEnabled'] == 1) {
      this.b2bPricingEnabled = true;
    } else {
      this.b2bPricingEnabled = false;
    }


  }

  thirdFormGroup = this._formBuilder.group({
    specialDiscount: [''],
  })

  @ViewChild('special') special: TemplateRef<any>;

  openDialog1() {
    let dialogRef = this.dialog.open(this.special, {
      width: '350px',
      disableClose: true,
      data: { field: this.field, group: this.group }
    });

    dialogRef.disableClose = true;
  }

  submit2() {
    if (this.thirdFormGroup.valid) {
      let val: any = this.thirdFormGroup.value.specialDiscount;

      let finalValue = this.group.value.price * (val / 100);
      if (finalValue > 0) {
        this.group.value.special_price = this.group.value.price - finalValue;
        this.group.patchValue(this.group.value)
      } else {
        this.group.value.special_price = 0.0;
        this.group.patchValue(this.group.value)
      }
      this.dialog.closeAll();
    }
    else {
      this.validateAllFormFields(this.thirdFormGroup);

    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  addSpecial(a: any) {
    this.openDialog1()
  }

  getSpecialPrice() {

    if (this.specialPriceChangeOnPriceDiscount == 1) {
      let val: any = this.group.value.discountPrice;
      if (val > 0) {
        let finalValue = this.group.value.price * (val / 100);
        this.group.value.special_price = this.group.value.price - finalValue;
        this.group.patchValue(this.group.value)
      } else {
        this.group.value.special_price = 0.0;
        this.group.patchValue(this.group.value)
      }

    }

  }

  priceUpdate(event): void {
    const inputElement = event.target.value;
    const weight = parseFloat(inputElement);

    console.log("weight", weight);


    if (this.group.get('MetalType') != undefined) {


      let rateId = this.group.value.MetalType;

      this.getMetalRatesById(rateId , weight)


    }

  }

  metalRates: any

  getMetalRatesById(id , weight) {
    this.metalRatesService.getMetalRatesById(id).subscribe(
      res => {

        this.metalRates = res;

        console.log("res", res);

        if(this.metalRates != null){
          let price = weight * this.metalRates.ratePerGram;
          this.group.get('price').setValue(price);
          this.group.get('MetalPrice').setValue(price);

        }

      },
      error => {

      }
    )

  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
